import React, { useCallback, useMemo, useState } from 'react';
import ImageGrid from './ImageGrid';
import Modal from './Modal';
import Title from './Title';
import Navbar from 'components/Navbar';
import useFirestore from '../hooks/useFirestore';
import { WHATSAPP_BOOKING_URL } from '../utils/contactDetails';
import '../styles/portfolio-detail.css';

const ImageDetails = props => {
  const [selectedImg, setSelectedImg] = useState(null);
  const imageType = props.match.params.id;
  const { docs } = useFirestore(imageType);
  const images = useMemo(() => docs.map((doc) => doc.url).filter(Boolean), [docs]);

  const navigateImage = useCallback((direction) => {
    if (images.length < 2) return;

    setSelectedImg((currentImg) => {
      const currentIndex = images.indexOf(currentImg);
      if (currentIndex < 0) return currentImg;
      const nextIndex = (currentIndex + direction + images.length) % images.length;
      return images[nextIndex];
    });
  }, [images]);

  const goToPreviousImage = useCallback(() => navigateImage(-1), [navigateImage]);
  const goToNextImage = useCallback(() => navigateImage(1), [navigateImage]);
  const selectedIndex = images.indexOf(selectedImg);

  return (
    <div className="portfolio-detail-page">
      <Navbar className="portfolio-detail-page__navbar" />
      <Title imageType={imageType} />

      <main className="portfolio-detail-content">
        <div className="portfolio-detail-content__inner">
          <div className="portfolio-detail-content__meta">
            <p className="portfolio-detail-content__eyebrow">The gallery</p>
            <p className="portfolio-detail-content__count">
              <span aria-hidden="true" />
              {docs.length} {docs.length === 1 ? 'photograph' : 'photographs'}
            </p>
          </div>

          <ImageGrid docs={docs} setSelectedImg={setSelectedImg} />

          <section className="portfolio-detail-cta" aria-labelledby="portfolio-detail-cta-title">
            <div>
              <p className="portfolio-detail-cta__eyebrow">Your moment, your look</p>
              <h2 id="portfolio-detail-cta-title">Let’s create something unforgettable.</h2>
              <p>Tell us about your occasion and we’ll help you plan the details.</p>
            </div>
            <a
              className="portfolio-detail-cta__button"
              href={WHATSAPP_BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp" aria-hidden="true" />
              Book an appointment
              <i className="fas fa-arrow-right" aria-hidden="true" />
            </a>
          </section>
        </div>
      </main>

      {selectedImg && (
        <Modal
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
          imageCount={images.length}
          currentIndex={selectedIndex}
          onPrevious={goToPreviousImage}
          onNext={goToNextImage}
        />
      )}
    </div>
  );
}

export default ImageDetails;
